<template>
  <SimplePage title="ぐるなび台帳ヘルプ">
    <main class="help">
      <div class="help-list separate">
        <div class="list sp">
          <BrowserOpen url="/pdf/smartphone.pdf">
            <div class="label">
              <SpIcon />
              <b>スマートフォン版のご案内</b>
            </div>
          </BrowserOpen>
        </div>
        <div class="list guide">
          <BrowserOpen url="http://daichoguide.gnavi.co.jp/">
            <div class="label">
              <LampIcon />
              <div>
                <p class="note">活用事例やお役立ち情報</p>
                <b>ぐるなび台帳活用ガイド</b>
              </div>
            </div>
          </BrowserOpen>
        </div>
      </div>
      <dl class="help-list">
        <dt class="title">台帳画面</dt>
        <dd
          class="list"
          v-for="([label, path], i) in [
            ['ログイン', '/pdf/login.pdf'],
            ['予約変更', '/pdf/reservationedit.pdf'],
            ['ホーム', '/pdf/home.pdf'],
            ['テーブル一覧', '/pdf/reservationtable.pdf'],
            ['ヘルプ', '/pdf/help.pdf'],
            ['テーブルレイアウト', '/pdf/reservationlayout.pdf'],
            ['お知らせ', '/pdf/information.pdf'],
            ['予約一覧', '/pdf/reservationlist.pdf'],
            ['アラート', '/pdf/alert.pdf'],
            ['受付履歴', '/pdf/history.pdf'],
            ['新規予約', '/pdf/reservation.pdf'],
            ['顧客台帳', '/pdf/customer.pdf'],
            ['予約詳細', '/pdf/reservationdetail.pdf'],
            ['分析', '/pdf/analytics.pdf'],
          ]"
          :key="i"
        >
          <BrowserOpen class="icon" :url="path">
            <div class="label">{{ label }}</div>
            <PdfIcon />
          </BrowserOpen>
        </dd>
      </dl>

      <dl class="help-list">
        <dt class="title">設定画面</dt>
        <dd
          class="list"
          v-for="([label, path], i) in [
            ['営業日設定', '/pdf/businessday.pdf'],
            ['スタッフ設定', '/pdf/staff.pdf'],
            ['営業時間設定', '/pdf/businesshour.pdf'],
            ['予約タグ設定', '/pdf/tag.pdf'],
            ['テーブル設定', '/pdf/table.pdf'],
            ['お客様特徴設定', '/pdf/attribute.pdf'],
            ['ログインユーザー設定', '/pdf/user.pdf'],
            ['コース設定', '/pdf/coursemenu.pdf'],
          ]"
          :key="i"
        >
          <BrowserOpen class="icon" :url="path">
            <div class="label">{{ label }}</div>
            <PdfIcon />
          </BrowserOpen>
        </dd>
      </dl>

      <dl class="help-list">
        <dt class="title">連携</dt>
        <dd
          class="list"
          v-for="([label, path], i) in [
            ['ぐるなびネット予約', '/pdf/gnavireserve.pdf'],
            ['他社グルメサイト', '/pdf/otherreserve.pdf'],
            ['POS+', '/pdf/gnavipostas.pdf'],
          ]"
          :key="i"
        >
          <BrowserOpen class="icon" :url="path">
            <div class="label">{{ label }}</div>
            <PdfIcon />
          </BrowserOpen>
        </dd>
        <dd class="list" />
      </dl>

      <dl class="help-list">
        <dt class="title">オプション</dt>
        <dd
          class="list"
          v-for="([label, path], i) in [
            ['台帳ネット予約', '/pdf/daichoreserve.pdf'],
            ['テイクアウト予約', '/pdf/takeout.pdf'],
            ['電話自動受付予約（IVR）', '/pdf/ivr.pdf'],
            ['着信顧客通知（CTI）', '/pdf/cti.pdf'],
            ['レスラク', '/pdf/resraku.pdf'],
          ]"
          :key="i"
        >
          <BrowserOpen class="icon" :url="path">
            <div class="label">{{ label }}</div>
            <PdfIcon />
          </BrowserOpen>
        </dd>
        <dd class="list" />
      </dl>

      <dl class="help-list">
        <dt class="title">操作説明動画</dt>
        <dd
          class="list"
          v-for="([label, path], i) in [
            ['導入説明', 'https://www.youtube.com/embed/qTzywNv5IJQ?rel=0'],
            ['ぐるなび予約連携設定の説明', 'https://www.youtube.com/embed/X0v1uw4tyxE?rel=0'],
            ['予約連携とは', 'https://www.youtube.com/embed/mdV8u_8iY0Y?rel=0'],
            ['相互連携設定の説明', 'https://www.youtube.com/embed/B_X_ufd6drQ?rel=0'],
          ]"
          :key="i"
        >
          <BrowserOpen class="icon" :url="path">
            <div class="label">{{ label }}</div>
            <MoviePlayIcon />
          </BrowserOpen>
        </dd>
      </dl>

      <dl class="help-list">
        <dt class="title">その他</dt>
        <dd class="list" v-for="([label, path], i) in [['推奨動作環境', '/pdf/systemrequirements.pdf']]" :key="i">
          <BrowserOpen class="icon" :url="path">
            <div class="label">{{ label }}</div>
            <PdfIcon />
          </BrowserOpen>
        </dd>
        <dd class="list" />
      </dl>

      <div class="call-to">
        <div class="call-info">
          <p><b>ぐるなび台帳に関するお問い合わせ</b></p>
          <p class="business-hours">営業時間 10:00〜18:00（土日祝を除く）</p>
        </div>
        <div class="phone-number">
          <TelIcon class="tel-icon" />
          <p>0120-22-9672</p>
        </div>
      </div>
    </main>
  </SimplePage>
</template>

<script>
import SimplePage from '@/components/templates/SimplePage'
import BrowserOpen from '@/components/atoms/BrowserOpen'
import PdfIcon from '@/components/icons/pdf'
import MoviePlayIcon from '@/components/icons/moviePlay'
import TelIcon from '@/components/icons/TelIcon'
import SpIcon from '@/components/icons/spImageLarge'
import LampIcon from '@/components/icons/lamp'

export default {
  name: 'Help',
  components: {
    SimplePage,
    BrowserOpen,
    PdfIcon,
    MoviePlayIcon,
    TelIcon,
    SpIcon,
    LampIcon,
  },
  data() {
    return {}
  },
  computed: {},
}
</script>

<style lang="postcss" scoped>
.help {
  display: grid;
  grid-gap: 32px;
  padding: 32px 124px;
}

.help-list {
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: 1fr 1fr;

  .title {
    align-items: center;
    background: var(--very-dark-gray);
    color: var(--white);
    display: grid;
    font-size: 13px;
    font-weight: 600;
    grid-column: 1 / span 2;
    height: 32px;
    justify-content: center;
  }

  .list {
    background: var(--white);
    border-bottom: solid 1px var(--border-color);

    &:nth-of-type(even) {
      border-left: solid 1px var(--border-color);
    }

    > a {
      display: grid;
      grid-auto-flow: column;
      height: 56px;
      justify-content: space-between;
      padding: 0 16px 0 32px;
    }
  }

  .label {
    align-items: center;
    color: var(--text-color);
    display: grid;
  }

  .icon {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: center;

    svg {
      fill: var(--moderate-blue);
      justify-self: end;
    }
  }

  &.separate {
    font-size: 21px;
    gap: 8px;
    .list {
      border: none;
      border-radius: 6px;

      a {
        grid-template-columns: 1fr;
        height: 86px;
        padding-left: 16px;
      }

      .label {
        gap: 16px;
        grid-template-columns: 56px 1fr;
      }

      &.sp svg {
        align-self: end;
      }

      &.guide {
        line-height: 1.4;
        .note {
          font-size: 13px;
        }
      }
    }
  }
}

.call-to {
  align-items: center;
  background-color: var(--white);
  display: flex;
  justify-content: space-between;
  padding: 16px 32px;
}

.call-info {
  line-height: 21px;
}

.business-hours {
  font-size: 12px;
}

.phone-number {
  display: flex;
  fill: var(--text-color);
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
}

.tel-icon {
  padding-right: 8px;
}
</style>
